module.exports = __webpack_public_path__ + "static/media/misDenuncias.69bc0f36.svg";